module.exports = __webpack_public_path__ + "src/assets/img/avanza.9861c0a2.png";